import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_PRODUCT_ADDITION_FAIL = "SHOP:UPSERT_PRODUCT_ADDITION_FAIL";

export const upsertProductAdditionFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_PRODUCT_ADDITION_FAIL as typeof UPSERT_PRODUCT_ADDITION_FAIL,
  organization,
  errors,
  id,
});

export type UpsertProductAdditionFailAction = ReturnType<
  typeof upsertProductAdditionFailAction
>;
